export const LMDB_ADMIN_PERMISSIONS = {
  READ_LMDB_ADMIN: ['read:lmdb-admin'],
  DELETE_LMDB_ADMIN_KEY: ['delete:lmdb-admin-key'],
  DELETE_LMDB_ADMIN_ALL: ['delete:lmdb-admin-all'],
  /** Start SEO URL cache config job from LMDB admin */
  START_SEO_CACHE_CONFIG: ['edit:start-seo-cache-config'],
};
